import React from 'react';
import PropTypes from 'prop-types';

import InputInlineEditable from 'core/gd-components/input-inline-editable/input-inline-editable';
import FieldsFactory1 from "../../../fields-factory";

export default class CostComponentProto extends React.Component {

    static propTypes = {
        type: PropTypes.oneOf(['cost-internal', 'cost-external', 'expenses']), // do not use gd.const, gd may not be initialized yet
        renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
        item: PropTypes.object,
    };

    getCurrencyMark = () => {
        return gd.const.currency[gd.company.financeCurrency].symbol;
    }

    getNormalizedValue = () => {
        const Field = FieldsFactory1.get(this.props.type)
        const value = Field.getValue(this.props.item);

        return gd.utils.Format.number(value,2,true);
    }

    render() {
        const value = this.getNormalizedValue();
        const currencyMark = this.getCurrencyMark();

        const classes = Classes('gd-field-currency', 'gd-custom-field-input-based', this.props.renderMode, 'chars-' + currencyMark.length, {
            disabled: true,
            'not-set': !value
        });

        const showCurrency = value !== null;
        const borderComponent = value && this.props.renderMode === 'list' ? <div className="value-border">{value}</div> : null
        return (
            <div className={classes}>
                {showCurrency && <div className="currency-mark-holder"><div className="currency-mark">{currencyMark}</div></div>}
                <InputInlineEditable value={value} disabled={true}/>
                {borderComponent}
            </div>
        );
    }
}
